<template>
  <v-sheet class="wsRoundedHalf mt-6">
    <h3 class="font-weight-medium">{{  $t('Timeline')  }}</h3>
    <v-timeline class="mt-6"  dense clipped >

      <!-- NEW EVENT -->
      <v-timeline-item  :color="wsACCENT">

        <template #icon><v-icon dark>mdi-plus</v-icon></template>

        <v-slide-x-transition mode="out-in">

          <v-sheet v-if="!addFile" class="wsRoundedHalf pa-3" :color="wsLIGHTCARD"  min-height="200">

            <v-text-field v-model="entityData.name" class="font-weight-bold" style="font-size: 0.83em" background-color="transparent" flat solo :placeholder="$t('EnterEventName')" dense  hide-details>
              <template #append>

                <div class="d-flex  align-center ">

                  <ft-select v-model="entityData.is_completed" :items="CHOICE_COMPLETED">
                    <wsChip :color="entityData.is_completed ? wsACCENT : 'grey'" centered class="mr-3"
                            :icon="entityData.is_completed ? 'mdi-check' : 'mdi-cog'"
                            :text="entityData.is_completed  ? $t('Completed')  : $t('InProcess')"  >
                      <v-icon small>mdi-chevron-down</v-icon>
                    </wsChip>
                  </ft-select>

                  <ft-select v-model="entityData.type" :items="eventTypes" :color="wsACCENT">
                    <template v-slot:default="{text}">
                      <v-chip :color="wsACCENT" outlined  class="px-4" >
                        <v-icon small class="mr-1">{{ getCrmEventIcon(entityData.type) }}</v-icon>
                        <h5 class="font-weight-medium">{{ text }}</h5>
                      </v-chip>
                    </template>
                  </ft-select>

                </div>

              </template>
            </v-text-field>

            <v-sheet color="transparent" >
              <v-textarea v-model="entityData.text"
                          style="font-size: 0.83em"
                          row-height="1" single-line
                          background-color="transparent"  auto-grow flat solo :placeholder="$t('EnterEventText')" dense  hide-details ></v-textarea>
            </v-sheet>

            <div class="d-flex px-3 mt-3 mb-6">
              <h5 class="mr-2">{{ $t('Manager') }}: </h5>
              <wsCrmAdminManagersSelect business class="ml-3 "  v-model="entityData.manager_id" />
            </div>
            <div class="d-flex px-3 mt-3 mb-6">
              <h5 class="mr-2">{{ !entityData.is_completed ? $t('DateScheduled') : $t('DateCompleted') }}: </h5>
              <ws-date-picker v-model="entityData.date_scheduled"
                              custom-activator>
                <wsChip :text="!entityData.date_scheduled ? $t('Today') : entityData.date_scheduled"
                        :color="wsACCENT"
                        icon="mdi-calendar" >
                </wsChip>
              </ws-date-picker>
            </div>

            <div class="d-flex pl-n3 pr-6 ">
              <v-btn block large elevation="0" rounded height="32" @click="addEvent"  rouned outlined :color="wsACCENT" class="noCaps ml-3 align-center">
                {{ $t('AddEvent') }}
              </v-btn>
            </div>

          </v-sheet>
          <ws-file-uploader v-if="addFile" no-id all-types @success="fileUploaded"   />
        </v-slide-x-transition>

        <v-simple-table class="mt-3" dense >
          <tbody>
          <tr v-for="(item,j) in entityData.files" :key="'files_' + j">
            <td style="border-bottom: none" width="10px"><v-icon :color="wsACCENT" small>mdi-file</v-icon></td>
            <td style="border-bottom: none" >{{ item.name }}</td>
          </tr>
          </tbody>
        </v-simple-table>

        <v-btn :color="wsACCENT" @click="addFile = !addFile" block text small class="noCaps mt-3"> {{ !addFile ? $t('AddFile') : $t('Back') }} </v-btn>

      </v-timeline-item>
      <!-- Events-->
      <v-timeline-item v-for="(item,i) in items"
                       :key="i"
                       class="my-3"
                       :color="getCrmEventColor(item.type)">
        <template #icon><v-icon dark small>{{ getCrmEventIcon(item.type) }}</v-icon></template>
        <v-sheet>
          <div class="d-flex justify-space-between align-center">
            <h5>{{ item.name }}</h5>
            <wsChip icon="mdi-calendar" :text="PARSE_TIME_STAMP(item.date_created,true)" />
          </div>

          <h5 v-html="item.text" class="font-weight-medium mt-3 mb-6" />

          <v-simple-table dense>
            <tbody>
            <tr class="pointer" @click="openFile(item)" v-for="(item,j) in item.files" :key="'files_' + j">
              <td style="border-bottom: none" width="10px"><v-icon :color="wsACCENT" small>mdi-file</v-icon></td>
              <td style="border-bottom: none">{{ item.name }}
              </td>
            </tr>
            </tbody>
          </v-simple-table>

          <div class="d-flex justify-space-between">

          </div>

          <wsChip class="mt-6" icon="mdi-account-tie"  >
            <h5><span class="font-weight-light">{{ $t('Created') }} :</span> {{ item.owner_name }}</h5>
          </wsChip>
          <wsChip v-if="item.manager_name"  icon="mdi-account-tie" >
            <h5><span class="font-weight-light">{{ $t('ManagerTodo') }} :</span> {{ item.manager_name }}</h5>
          </wsChip>


        </v-sheet>
      </v-timeline-item>

    </v-timeline>
  </v-sheet>
</template>

<script>
import {mapActions} from "vuex";
import wsCrmAdminManagersSelect from "@/components/pages/adminDashboard/UI/wsCrmAdminManagersSelect";

export default {
  name: "clientTimeline",
  components : {
    wsCrmAdminManagersSelect
  },
  props : {
    uuid : {
      type : String,
      default : ''
    }
  },
  data() {
    return {
      items: [],
      addFile : false,
      entityData : {
        type : 'note',
        files : [],
        is_completed : true
      },
      defaultEntityData : {
        type : 'note',
        files : [],
        is_completed : true
      },
      selectedFile : {},

    }
  },
  computed : {
    eventTypes() {
      return [
        { text : this.$t('Note')      , value : 'note'       },
        { text : this.$t('Call')      , value : 'call'       },
        { text : this.$t('VideoCall') , value : 'video_call' },
        { text : this.$t('Task')      , value : 'task'       },
        { text : this.$t('File')      , value : 'file'       },
        { text : this.$t('Bug')       , value : 'bug'       }
      ]
    }
  },
  methods : {
    ...mapActions( 'crmSystem', [
        'GET_BUSINESS_CLIENT_EVENTS' ,
        'ADD_BUSINESS_CLIENT_EVENT'
    ] ),
    ...mapActions('upload', [ 'GET_PRIVATE_FILE' ]),

    async addEvent() {

      if ( !this.entityData.text && !this.entityData.name) {
        return this.notify(this.$t('PleaseEnterNameOrText'))
      }

      this.entityData.user_id = this.uuid
      if ( this.entityData.text ) {
        this.entityData.text = this.entityData.text.replace(/\n/gi, '<br>');
      }

      let result = await this.ADD_BUSINESS_CLIENT_EVENT(this.entityData)
      if (!result) {
        return this.notify(this.$t('Error'))
      }
      this.items.unshift(result)
      this.entityData = JSON.parse(JSON.stringify(this.defaultEntityData))
      this.notify(this.$t('ChangesSaved'))
    },
    fileUploaded($event) {
      this.entityData.files.push($event)
      this.addFile = false
      this.notify(this.$t('FileUploaded'))
    },
    async openFile(file) {
      let result = await this.GET_PRIVATE_FILE(file.uuid)
      if (!result) { return this.notify('File Not found') }
      var a = document.createElement('a');
      a.href = result.url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    getCrmEventIcon(type) {
      switch(type) {
        case 'note' : return 'mdi-notebook';
        case 'call' : return 'mdi-phone';
        case 'video_call' : return 'mdi-video';
        case 'task' : return 'mdi-checkbox-marked-outline';
        case 'file' : return 'mdi-file';
        case 'user_registration' : return 'mdi-account'
        case 'client_order' : return 'mdi-cart'
        case 'order_payment' : return 'mdi-cash'
        case 'status_change' : return 'mdi-cog';
        case 'course_enrollment' : return 'mdi-school'
        default : return 'mdi-cog';
      }
    },
    getCrmEventColor(type) {
      switch(type) {
        case 'note' : return 'orange';
        case 'call' : return 'green lighten-1';
        case 'video_call' : return 'blue lighten-1';
        case 'task' : return 'teal lighten-1';
        case 'file' : return 'primary lighten-1';
        case 'user_registration'  : return 'green lighten-2';
        case 'client_order' : return 'teal lighten-1'
        case 'order_payment' : return 'green lighten-1'
        case 'status_change' : return 'purple lighten-1';
        case 'course_enrollment' : return 'primary lighten-1'
        default : return 'mdi-cog';
      }
    },

    async initPage() {
      let result = await this.GET_BUSINESS_CLIENT_EVENTS(this.uuid)

      if ( !result || result === true ) {
        return
      }

      this.items = result

    }
  },
  mounted() {
    this.initPage()
  }


}
</script>

<style scoped>

</style>